import React from "react";
import { FieldRendererProps } from "../types";
import { CampoContainer, AjudinhaWrapperCheckbox } from "../styles";
import Ajudinha from "../../ajudinha";
import indisponivel from "../../../assets/indisponivel.png";

export const PhotoFieldRenderer: React.FC<FieldRendererProps> = ({
  campo, getFieldValue,
}) => (
  <CampoContainer>
    <img
      src={getFieldValue(campo.nome)}
      alt="media"
      style={{ marginBottom: "-10px" }}
      className="custom-checkbox"
      onError={(e) => {
        e.currentTarget.onerror = null;
        e.currentTarget.src = indisponivel;
      }}
    />
    {campo.ajudinha?.texto && (
      <AjudinhaWrapperCheckbox>
        <Ajudinha texto={campo.ajudinha.texto} autoCloseTime={campo.ajudinha.autoCloseTime} />
      </AjudinhaWrapperCheckbox>
    )}
  </CampoContainer>
);
